module.exports = __webpack_public_path__ + "img/part4-watermark.76cae048.png";